import axios from 'axios';
import actions from '../actions/license';

export default {
	namespaced: true,
	actions: {
		[actions.GET_LICENSE]: async ({ rootState }, { organizationId }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'license' && x.templated);

				const href = link.href
					.replace('{organizationId}', organizationId);

				const response = await axios.get(href);

				if (navigator.msSaveBlob) {
					const blobObject = new Blob([response.data]);

					window.navigator.msSaveOrOpenBlob(blobObject, 'PROGRAM.VRS');
				} else {
					const fileURL = window.URL.createObjectURL(new Blob([response.data]));

					const fileLink = document.createElement('a');

					fileLink.href = fileURL;

					fileLink.setAttribute('download', 'PROGRAM.VRS');

					document.body.appendChild(fileLink);

					fileLink.click();
				}
			} catch (error) {
				throw error;
			}
		},
	},
};
